
import customPluralRule from "@/shared/utils/customPlural"
import { createI18n } from "vue-i18n"
import enUS from "./locales/en.json"
import ruRU from "./locales/ru.json"

export default createI18n({
    legacy: false,
    locale: import.meta.env.VITE_I18N_LOCALE,
    // locale: import.meta.env.VITE_I18N_LOCALE,
    fallbackLocale: import.meta.env.VITE_I18N_FALLBACK_LOCALE,
    messages: {
        ru: ruRU,
        en: enUS
    },
    pluralRules: { ru: customPluralRule }
})
